<script lang="ts">
	import { classes } from '@thearc-hq/ui-kit/utils';
	import ChevronHorizontalButton from '../Button/ChevronHorizontalButton.svelte';

	export let className: string = '';
	export let additionalClass: string = '';
	export let labelClass: string = '';
	export let title: string;
	export let label: string | undefined = undefined;
	export let backButton: boolean = false;

	export { className as class };

	const handleClick = () => {
		history.back();
	};

	const handleKeypress = (event: KeyboardEvent) => {
		if (event.key === 'Enter') {
			history.back();
		}
	};
</script>

<div
	class={classes(
		className,
		'flex flex-col-reverse w-full md:items-center md:justify-between md:flex-row'
	)}
>
	<h2 class={classes(additionalClass, 'text-h-24 md:text-h-32')}>{title}</h2>
	{#if label}
		<span class={classes('text-white rounded text-h-12 py-1 px-2 mb-2 lg:mb-0', labelClass)}>
			{label}
		</span>
	{/if}
	{#if backButton}
		<ChevronHorizontalButton
			on:click={handleClick}
			on:keypress={handleKeypress}
			additionalClass="flex items-center h-12 rounded hover:bg-dark-background pr-4 -mr-4 mb-10 font-extrabold cursor-pointer text-h-16 gap-x-1 text-accent-primary md:mb-0 whitespace-nowrap"
			role="link"
			chevronLeft={true}
		/>
	{/if}
</div>
